import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { TranslateModule } from "@ngx-translate/core";
import { BankIdModule } from "@obg/common.bankid";
import { TooltipDirectiveModule } from "@obg/mat.ui.common/tooltip";
import { DialogLayoutModule, OverlaySpinnerModule } from "@obg/mat.ui.core";
import { MatGlobalModule } from "@obg/mat.ui.global";
import {
	CommonValidationRendererModule,
	CountdownProgressBarModule,
	PasswordStrengthModule,
	TogglePasswordModule,
} from "@obg/ngx.ui.common";
import { CompactFooterModule, ComponentFactoryService, CoreUiModule } from "@obg/ngx.ui.core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { SgaSetPasswordContainer } from "./sga-set-password.container";

@NgModule({
	imports: [
		CommonModule,
		MatButtonModule,
		MatMenuModule,
		MatFormFieldModule,
		MatIconModule,
		MatInputModule,
		ReactiveFormsModule,
		DialogLayoutModule,
		TranslateModule,
		CompactFooterModule,
		CoreUiModule,
		GlobalUiModule,
		MatGlobalModule,
		CountdownProgressBarModule,
		TooltipDirectiveModule,
		PasswordStrengthModule,
		TogglePasswordModule,
		OverlaySpinnerModule,
		CommonValidationRendererModule,
		BankIdModule,
	],
	exports: [SgaSetPasswordContainer],
	declarations: [SgaSetPasswordContainer],
})
export class SgaSetPasswordModule {
	constructor(resolver: ComponentFactoryResolver, componentFactoryService: ComponentFactoryService) {
		componentFactoryService.registerLazyLoadedResolver(resolver, SgaSetPasswordContainer);
	}
}
